import { useEffect, useState } from "react";
import {
  Box,
  CircularProgress,
  Container,
  Divider,
  Grid,
  Typography,
} from "@mui/material";
import { useQuery } from "hooks/useQuery";
import { useAuthToken } from "hooks/useAuthToken";
import { getDetailShoppingExpress } from "services/shoppingExpress";
import Error from "components/Error";
import { ERROR_REFERENCES } from "./helpers/customTextLabels";
import { formatCurrency } from "utils/misc";

export default function DetailShoppingExpress({ setCurrentBrand }) {
  const { getAuthToken } = useAuthToken();
  const query = useQuery();
  const currentBrand = query.get("b");
  const uuid = query.get("uuid");
  const [loading, setLoading] = useState(false);
  const [detail, setDetail] = useState({});

  // error
  const [messageError, setMessageError] = useState("");

  const fnSetterError = (message) => {
    setMessageError(message);
  };

  useEffect(() => {
    const fnInitialization = async () => {
      try {
        setLoading(true);
        localStorage.setItem("current_brand", currentBrand);
        setCurrentBrand(currentBrand);
        await getAuthToken();
      } catch (err) {
        console.error(err);
      }
    };
    fnInitialization();
  }, []);

  useEffect(() => {
    if (!uuid || !currentBrand || !["1", "2", "3"].includes(currentBrand)) {
      fnSetterError(ERROR_REFERENCES);
      return setLoading(false);
    }

    const fnGetDetail = async () => {
      try {
        const {
          data: { status, data },
        } = await getDetailShoppingExpress(uuid);
        if (status === "success") {
          setDetail(data);
        }

        if (status === "error") {
          const { message } = data?.data;
          fnSetterError(message ?? ERROR_REFERENCES);
        }
      } catch (err) {
        fnSetterError(ERROR_REFERENCES);
      } finally {
        setLoading(false);
      }
    };
    localStorage.getItem("access_token_bt") && fnGetDetail();
  }, [localStorage.getItem("access_token_bt"), uuid, currentBrand]);

  if (loading) {
    return (
      <Box
        maxWidth="100%"
        height="98vh"
        sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Container maxWidth="md" height="98vh">
      {messageError ? (
        <Error
          message={messageError}
          customTitle={messageError}
          linkButton=""
        />
      ) : (
        <Grid
          container
          spacing={2}
          py={{ xs: 2, md: 3 }}
          px={{ xs: 3, md: 12 }}
        >
          <Grid item xs={12}>
            <Typography variant="title" color="primary">
              Detalles {detail?.product_name}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="title" color="primary">
              Pago {detail?.payment_status}
            </Typography>
          </Grid>
          <Grid item xs={12} md={12}>
            <Grid container spacing={2}>
              <Grid item xs={4}>
                <Typography
                  variant="subtitle2"
                  color="textSecondary"
                  fontWeight={601}
                >
                  Nombre
                </Typography>
              </Grid>
              <Grid item xs={8}>
                <Typography variant="subtitle2" align="right" fontWeight={701}>
                  {`${detail?.first_name} ${detail.last_name}`}
                </Typography>
              </Grid>
              <Grid item xs={4}>
                <Typography
                  variant="subtitle2"
                  color="textSecondary"
                  fontWeight={601}
                >
                  Documento
                </Typography>
              </Grid>
              <Grid item xs={8}>
                <Typography variant="subtitle2" align="right" fontWeight={701}>
                  {detail?.doc_type} {detail?.doc_number}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Divider />
              </Grid>

              <Grid item xs={4}>
                <Typography
                  variant="subtitle2"
                  color="textSecondary"
                  fontWeight={601}
                >
                  Total
                </Typography>
              </Grid>
              <Grid item xs={8}>
                <Typography variant="subtitle2" align="right" fontWeight={701}>
                  {formatCurrency(detail?.total, currentBrand)}
                </Typography>
              </Grid>
              <Grid item xs={4}>
                <Typography
                  variant="subtitle2"
                  color="textSecondary"
                  fontWeight={601}
                >
                  Referencia
                </Typography>
              </Grid>
              <Grid item xs={8}>
                <Typography variant="subtitle2" align="right" fontWeight={701}>
                  {detail?.uuid}
                </Typography>
              </Grid>
              <Grid item xs={4}>
                <Typography
                  variant="subtitle2"
                  color="textSecondary"
                  fontWeight={601}
                >
                  ID pasarela
                </Typography>
              </Grid>
              <Grid item xs={8}>
                <Typography variant="subtitle2" align="right" fontWeight={701}>
                  {detail?.ref_gateway}
                </Typography>
              </Grid>
              <Grid item xs={4}>
                <Typography
                  variant="subtitle2"
                  color="textSecondary"
                  fontWeight={601}
                >
                  {"Franquicia"}
                </Typography>
              </Grid>
              <Grid item xs={8}>
                <Typography variant="subtitle2" align="right" fontWeight={701}>
                  {detail?.franchise}
                </Typography>
              </Grid>
              <Grid item xs={4}>
                <Typography
                  variant="subtitle2"
                  color="textSecondary"
                  fontWeight={601}
                >
                  Dirección IP
                </Typography>
              </Grid>
              <Grid item xs={8}>
                <Typography variant="subtitle2" align="right" fontWeight={701}>
                  {detail?.ip_address}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <br />
              </Grid>
              <Grid item xs={4}>
                <Typography
                  variant="subtitle2"
                  color="textSecondary"
                  fontWeight={601}
                >
                  Razón social
                </Typography>
              </Grid>
              <Grid item xs={8}>
                <Typography
                  variant="subtitle2"
                  align="right"
                  textAlign="justify"
                  fontWeight={701}
                >
                  {detail?.company?.name}
                </Typography>
              </Grid>
              <Grid item xs={4}>
                <Typography
                  variant="subtitle2"
                  color="textSecondary"
                  fontWeight={601}
                >
                  NIT
                </Typography>
              </Grid>
              <Grid item xs={8}>
                <Typography variant="subtitle2" align="right" fontWeight={701}>
                  {detail?.company?.nit}
                </Typography>
              </Grid>
              <Grid item xs={4}>
                <Typography
                  variant="subtitle2"
                  color="textSecondary"
                  fontWeight={601}
                >
                  Dirección
                </Typography>
              </Grid>
              <Grid item xs={8}>
                <Typography variant="subtitle2" align="right" fontWeight={701}>
                  {detail?.company?.address}
                </Typography>
              </Grid>
              <Grid item xs={4}>
                <Typography
                  variant="subtitle2"
                  color="textSecondary"
                  fontWeight={601}
                >
                  Ciudad
                </Typography>
              </Grid>
              <Grid item xs={8}>
                <Typography variant="subtitle2" align="right" fontWeight={701}>
                  {detail?.company?.city}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      )}
    </Container>
  );
}
